module.exports = __webpack_public_path__ + "static/media/B_S02.43cdf618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_S02.png
// module id = 67
// module chunks = 0